import { html } from 'lit';
import { HelpCircle } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-help-circle')
export class PdsIconHelpCircle extends PdsIcon {
  @state()
  icon = HelpCircle;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
